import { useTranslation } from 'next-i18next'

import QuestionIconWithTooltip from '~/shared/components/QuestionIconWithTooltip/QuestionIconWithTooltip'
import SelectorItem from '~/components/SelectorItem/SelectorItem'

export default function SelectPhysicalLocation({
  includeTravelExpense,
  allowOtherLocation = true,
  onClick,
}: {
  includeTravelExpense: boolean
  onClick: (includeTravelExpense: boolean) => void
  allowOtherLocation?: boolean
}): React.ReactElement {
  const { t } = useTranslation('booking')

  return (
    <div className="px-4 py-3 flex flex-col items-center bg-pink-light rounded">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col items-center">
          <SelectorItem className="h-full" isSelected={!includeTravelExpense} onClick={() => onClick(false)}>
            {t('location.physicalLocationHouseOfMath')}
          </SelectorItem>
          <span className="mt-1 text-xxs text-gray-light-fade">{t('location.additionalCostNone')}</span>
        </div>
        <div className="relative flex flex-col items-center">
          <SelectorItem
            className="h-full"
            isDisabled={!allowOtherLocation}
            isSelected={includeTravelExpense}
            onClick={() => onClick(true)}
          >
            {t('location.yourLocation')}
          </SelectorItem>
          <QuestionIconWithTooltip className="absolute -top-2 -right-2">
            {t('location.physicalLocationOtherTooltipText')}
          </QuestionIconWithTooltip>
          <span className="mt-1 text-xxs text-gray-light-fade">{t('location.additionalCost')}</span>
        </div>
      </div>
    </div>
  )
}
